import { OnInit, Component } from "@angular/core";
import { DatePipe } from "@angular/common";

import { HttpErrorResponse } from "@angular/common/http";
import { NzNotificationService } from "ng-zorro-antd";

import { GlobalComponent, Result, Aziende, Dipendente, Ordine } from "../../environments/global";

@Component({
	selector: "app-incidenze-report",
	templateUrl: "incidenze.report.html",
	styleUrls: ["incidenze.report.scss"],
	providers: [DatePipe],
})
export class IncidenzeReportComponent implements OnInit {
	// TABLE VARS
	timesData = [];
	public displayData = [...this.timesData];
	ordersData = [];
	editCache = {};
	sortName = null;
	sortValue = null;
	// COMPONNET VARS
	companyData: Array<string> = Aziende;
	isSpinning: boolean = false;
	isLoading: boolean = false;
	selectedCompany: string;
	selectedOrders = [];
	selectedMonth: Date;
	selectedOrder: Ordine;
	statusFilter: boolean = true;
	totalSwitch: boolean = false;
	currentTotale: string = "Totale ore: 0";
	dateFormat = "dd/MM/yyyy";

	// ################################################
	// CLASS: CONSTRUCTOR
	constructor(public g: GlobalComponent, private datepipe: DatePipe, private notification: NzNotificationService) {
		this.setup();
	}
	// ################################################
	// CLASS: ON INIT
	ngOnInit() {
		this.setup();
		this.loadData();
	}
	setup() {
		// SETUP INTERFACE
		this.g.menuState = 7;
		this.g.homeTitle = "Report Incidenze";
	}
	loadData(reSelect: boolean = false) {
		this.isSpinning = true;
		const query: string = "SELECT * from chk_orders WHERE `status`=" + (this.statusFilter ? "1" : "0");
		this.g.mysql(query).subscribe(
			(res: Result) => {
				this.ordersData = res.data;
				this.isSpinning = false;
				if (reSelect) {
					this.selectedOrder = null;
					this.selectOrders();
				}
			},
			(error: HttpErrorResponse) => {
				this.isSpinning = false;
				this.notification.error("Si è vericato un errore non previsto", error.statusText, { nzDuration: 0 });
			}
		);
	}
	selectOrders() {
		if (this.selectedCompany) {
			this.selectedOrders = this.ordersData.filter((o) => o.company === this.selectedCompany);
			this.selectedOrder = null;
		}
	}
	loadTimes() {
		this.isLoading = true;

		// tslint:disable-next-line:max-line-length
		let query: string =
			"SELECT chk_times.id, chk_times.userId, Sum(chk_times.h) As Sum_h, chk_users.name, chk_users.surname FROM chk_times INNER JOIN chk_users ON chk_users.id = chk_times.userId INNER JOIN chk_orders ON chk_orders.id = chk_times.orderId" +
			" WHERE `orderId`=" +
			this.selectedOrder.id +
			" GROUP BY chk_times.userId,	chk_times.orderId, chk_users.name, chk_users.surname";

		query += " ORDER BY chk_users.name";

		console.log(query);

		return this.g.mysql(query).subscribe(
			(res: Result) => {
				this.isLoading = false;

				let totaleOre: number = 0;
				res.data.forEach((t) => {
					totaleOre += t.Sum_h;
				});
				this.currentTotale = totaleOre > 0 ? "Totale ore: " + totaleOre : "";

				if (totaleOre > 0) {
					res.data.forEach((t) => {
						const incidenza:number = ((t.Sum_h * 100) / totaleOre);
						t.incidenza = (incidenza > 1) ? incidenza.toFixed(0) + "%" : "<1%";
					});
				}

				this.timesData = res.data;
				this.displayData = [...this.timesData];
			},
			(error: HttpErrorResponse) => {
				this.isLoading = false;
				this.notification.error("Si è vericato un errore non previsto", error.statusText, {
					nzDuration: this.g.normalTime,
				});
			}
		);
	}

	sort(sort: { key: string; value: string }): void {
		this.sortName = sort.key;
		this.sortValue = sort.value;
		if (this.sortName) {
			this.displayData = [
				...this.timesData.sort((a, b) =>
					this.sortValue === "ascend"
						? a[this.sortName] > b[this.sortName]
							? 1
							: -1
						: b[this.sortName] > a[this.sortName]
							? 1
							: -1
				),
			];
		} else {
			this.displayData = [...this.timesData];
		}
	}
}
